export default __webpack_public_path__ + "static/media/5198.75bd06b9.png";